{
  "cycle.entite.attention_reports": "Attention item postponements",
  "cycle.entite.conditions_acceptations": "Terms of use acceptances",
  "cycle.entite.confirmations_identite": "Identity confirmations",
  "cycle.entite.delegation_droits": "Rights passed on by delegation",
  "cycle.entite.entrees_brouillons": "Input drafts",
  "cycle.entite.evenements_prestataire": "Events received from the payment provider",
  "cycle.entite.exports_personnels": "Personal data exports",
  "cycle.entite.favoris": "Favourite spaces",
  "cycle.entite.formules_score": "Item score formulas",
  "cycle.entite.jetons_personnels": "Personal tokens",
  "cycle.entite.operations_paiement": "Payment operations",
  "cycle.entite.organisation_premiers_pas_masques": "Hidden getting-started steps",
  "cycle.entite.preferences_affichage": "Display preferences",
  "cycle.entite.preuves_source_elements": "Item source evidence",
  "cycle.entite.programme_decisions_comite": "Programme committee decisions",
  "cycle.entite.profils_personnels": "Personal profiles",
  "cycle.entite.rapprochements": "Payment reconciliations",
  "cycle.entite.rattachements_proposes": "Programme attachment proposals",
  "cycle.entite.reactions": "Reactions to items and comments",
  "cycle.entite.recents": "Recently visited spaces",
  "cycle.entite.sante_publications": "Project health publications",
  "cycle.entite.sessions_fermees": "Closed sessions",
  "cycle.entite.statuts_personnels": "Absence statuses",
  "cycle.entite.suivis_objets": "Followed objects",
  "cycle.entite.tests_quarantaine": "Test case quarantines",
  "journalAudit.action.account.deletion_cancelled": "Account deletion cancelled",
  "journalAudit.action.account.deletion_requested": "Account deletion requested",
  "journalAudit.action.account.display_preferences_updated": "Display preferences updated",
  "journalAudit.action.account.export_created": "Personal data export prepared",
  "journalAudit.action.account.export_downloaded": "Personal data export downloaded",
  "journalAudit.action.account.profile_updated": "Personal profile updated",
  "journalAudit.action.account.status_updated": "Absence status updated",
  "journalAudit.action.account.terms_accepted": "Terms of use accepted",
  "journalAudit.action.backlog.implement_requested": "Code generation launch requested",
  "journalAudit.action.invitation.declined": "Project invitation ignored",
  "journalAudit.action.organisation.premiers_pas_affiches": "Getting started shown again",
  "journalAudit.action.organisation.premiers_pas_masques": "Getting started hidden",
  "journalAudit.action.point.created": "Question added on a document",
  "journalAudit.action.point.verified": "Answer integration attested",
  "journalAudit.action.project.attachment_accepted": "Programme attachment accepted",
  "journalAudit.action.project.attachment_refused": "Programme attachment refused",
  "journalAudit.action.project.health_published": "Project health published",
  "journalAudit.action.project.role_designated": "Project role designated",
  "journalAudit.action.test_case.quarantaine_levee": "Test case quarantine lifted",
  "journalAudit.action.test_case.quarantaine_posee": "Test case quarantined",
  "journalAudit.action.workspace.deletion_solicited": "Project deletion requested"
}
